module.exports = __webpack_public_path__ + "static/media/warning.983d14b1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/alerts/warning.svg
// module id = 540
// module chunks = 0